import React, { Component } from 'react'
import { connect } from 'react-redux';
import axios from 'axios'
import './ISARDetailModal.css'
import { Modal, Pagination, message } from 'antd'
import closeImg from '../static/closeImg.png'
import ReactDOM from 'react-dom';
// import attributeThumb from '../static/attributeThumb.png'
import sampleThunb from '../static/sampleThunb.png'
import { SampleAttributeCompareTable, ISARProductAttributeCompareTable } from '../Public/PublicData'


class ISARDetailModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            // isVisible: false,//是否显示ISAR详情弹窗
            sampleThumbnailsPath: '',//样本缩略图路径
            ISARFeatureGraphicPath: '',//ISAR产品缩略图路径
            samplePropetyComparisionArray: [],//样本属性参数数组
            productPropetyComparisionArray: [],//产品参数数组
        }
    }

    componentDidMount() {
        console.log(this.props.selcetItem)
        this.getMicroRSFeatureGraphicPath()
        this.getMicroRSFeatureISARGraphicPath()
        this.handleParamsComparisionTable()
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.selcetItem !== prevProps.selcetItem) {

            this.getMicroRSFeatureGraphicPath()
            this.getMicroRSFeatureISARGraphicPath()
            this.handleParamsComparisionTable()
        }
    }

    // componentWillReceiveProps(props) {
    //   this.setState({
    //     isVisible: props.isVisible
    //   })
    // }
    /**
     * @description: 处理对照表
     * @event: paramsComparisionTable
     * @return {*}
     */

    handleParamsComparisionTable = () => {
        const { samplePropetyComparision, productPropetyComparision } = this.props
        if (samplePropetyComparision) {
            let samplePropetyName = samplePropetyComparision.field_meaning.split(',')
            let samplePropetyValue = samplePropetyComparision.field_name.split(',')
            let tempArray = [samplePropetyName, samplePropetyValue]
            this.setState({
                samplePropetyComparisionArray: tempArray
            }, () => {
                console.log(this.state.samplePropetyComparisionArray)
            })
        }
        if (productPropetyComparision) {
            let productPropetyName = productPropetyComparision.field_meaning.split(',')
            let productPropetyValue = productPropetyComparision.field_name.split(',')
            let tempArray = [productPropetyName, productPropetyValue]
            this.setState({
                productPropetyComparisionArray: tempArray
            }, () => {
                console.log(this.state.productPropetyComparisionArray)
            })
        }
    }

    /**
     * @description: 获取ISAR样本缩略图
     * @event: getMicroRSFeatureGraphicPath
     * @return {*}
     */
    getMicroRSFeatureGraphicPath = async () => {
        const { zd_user } = this.props
        if (this.props.selcetItem) {
            let dataNamesArray = []
            dataNamesArray.push(this.props.selcetItem.product_name)
            let dataPath = this.props.selcetItem.sample_photo_file_location.replace(/\\/g, '%5C')
            const { data: res } = await axios.get(`/zdUrl/api/getMicroRSFeatureGraphicPath?dataNames=${dataNamesArray}&dataPath=${dataPath}`, {
                headers: {
                    Authorization: zd_user.token,
                }
            })
            // console.log('getMicroRSFeatureGraphicPath', res)
            if (res.code === '0') {
                let dataNames = this.props.selcetItem.product_name
                this.setState({
                    sampleThumbnailsPath: res.data[dataNames].replace("http://10.0.121.14:8084", "https://caplos.aircas.ac.cn/zdTiles")
                })
            } else {
                message.error("样本图片获取失败")
            }
        } else {
            return
        }
    }
    /**
     * @description: 获取ISAR产品缩略图
     * @event: getMicroRSFeatureISARGraphicPath
     * @return {*}
     */
    getMicroRSFeatureISARGraphicPath = async () => {
        const { zd_user } = this.props
        if (this.props.selcetItem) {
            let dataPaths = []
            dataPaths.push(this.props.selcetItem.data_file_location.replace(/\\/g, '%5C'))
            const { data: res } = await axios.get(`/zdUrl/api/getMicroRSFeatureISARGraphicPath?dataPaths=${dataPaths}`, {
                headers: {
                    Authorization: zd_user.token,
                }
            })
            if (res.code === '0') {
                let dataNames = this.props.selcetItem.product_name + '.zip'
                console.log('getMicroRSFeatureISARGraphicPath', res.data, dataNames[0], res.data[dataNames])
                this.setState({
                    ISARFeatureGraphicPath: res.data[dataNames]
                })
            } else {
                message.error("产品预览图获取失败")
            }
        } else {
            return
        }
    }
    /**
     * @description: 关闭详情弹窗
     * @event:
     * @return {*}
     */
    closeISARModal = () => {
        this.props.closeDetailModal()
    }


    render() {
        const { selcetItem } = this.props
        const { ISARFeatureGraphicPath, sampleThumbnailsPath } = this.state;

        return (
            <div className="isar-detail-display-modal-content-wrap">
                <div className="isar-detail-display-modal-content-top-wrap">
                    <div className="isar-detail-display-modal-content-left-top-wrap">
                        <div className="isar-detail-display-modal-content-left-top-title">样本属性参数</div>
                        <div className="isar-detail-display-modal-content-left-top-content">
                            <div className="isar-detail-display-modal-content-left-top-attributewrap">
                                {
                                    this.state.samplePropetyComparisionArray[0] && this.state.samplePropetyComparisionArray[0].map(element => {
                                        return <div
                                            className="isar-detail-display-modal-content-left-top-attribute-name"
                                            key={element} title={element}>{element}：</div>
                                    })
                                }
                            </div>
                            <div className="isar-detail-display-modal-content-left-top-resultwrap">
                                {
                                    this.state.samplePropetyComparisionArray[1] && this.state.samplePropetyComparisionArray[1].map(element => {
                                        return <div
                                            className="isar-detail-display-modal-content-left-top-attribute-value"
                                            key={element} title={selcetItem[element]}>{selcetItem[element]}</div>
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <div className="isar-detail-display-modal-content-right-top-wrap">
                        <div className="isar-detail-display-modal-content-right-top-title">ISAR产品参数</div>
                        <div className="isar-detail-display-modal-content-right-top-content">
                            <div className="isar-detail-display-modal-content-right-top-attributewrap">
                                {
                                    this.state.productPropetyComparisionArray[0] && this.state.productPropetyComparisionArray[0].map(element => {
                                        return <div
                                            className="isar-detail-display-modal-content-right-top-attribute-name"
                                            key={element} title={element}>{element}：</div>
                                    })
                                }
                            </div>
                            <div className="isar-detail-display-modal-content-right-top-resultwrap">
                                {
                                    this.state.productPropetyComparisionArray[1] && this.state.productPropetyComparisionArray[1].map(element => {
                                        return <div
                                            className="isar-detail-display-modal-content-right-top-attribute-value"
                                            key={element} title={selcetItem[element]}>{selcetItem[element]}</div>
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="isar-detail-display-modal-content-bottom-wrap">
                    <div className="isar-detail-display-modal-content-left-bottom-wrap">
                        <div className="isar-detail-display-modal-content-left-bottom-tittle">样本图片</div>
                        <img src={
                            sampleThumbnailsPath ?
                                sampleThumbnailsPath.replace("http://10.0.121.14:8084", "https://124.16.188.131:9599/zdTiles") :
                                null
                        }
                            className="isar-detail-display-modal-content-left-bottom-img"></img>
                        {/* <Pagination
                                className="isar-detail-display-modal-content-left-bottom-pagination"
                                simple
                                total={13}
                                defaultPageSize={1}
                            ></Pagination> */}
                    </div>
                    <div className="isar-detail-display-modal-content-right-bottom-wrap">
                        <div className="isar-detail-display-modal-content-right-bottom-tittle">产品预览</div>
                        <img src={
                            ISARFeatureGraphicPath ?
                                ISARFeatureGraphicPath.replace("http://10.0.121.14:8084", "https://caplos.aircas.ac.cn/zdTiles") :
                                null
                        }
                            className="isar-detail-display-modal-content-right-bottom-img"></img>
                    </div>
                </div>
            </div>
            // <Modal
            //     className="isar-detail-display-modal"
            //     header={null}
            //     visible={this.props.isVisible}
            //     footer={null}
            //     closable={false}
            // >
            //     {/*<div className="isar-detail-display-modal-hedar-wrap">
            //         <div className="isar-detail-display-modal-hedar-title">ISAR影像产品详情展示</div>
            //         <img src={closeImg} className="isar-detail-display-modal-hedar-closeImg"
            //              onClick={() => this.closeISARModal()}></img>
            //     </div>*/}
            // </Modal>
        )
    }
}

const mapState = (state) => ({ //返回值  对应的是  组件的props
    user: state.userReducer.get('user').toJS(),
    zd_user: state.userReducer.get('zd_user').toJS(),
})
export default connect(mapState)(ISARDetailModal)